/**
 * Audit Hub constants aligned to the Audit Hub OpenAPI.
 *
 * Lifecycle status query enum: draft | active | completed | cancelled.
 * POST /audits creates a draft shell. Accounts are added with
 * POST /audits/{id}/accounts, then POST /audits/{id}/launch starts the scans.
 * Each account has its own regions (max 32) and complianceAddonIds (1–32).
 */

export const AUDIT_STATUSES = {
  DRAFT: "draft",
  ACTIVE: "active",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};

export const AUDIT_STATUS_LABEL = {
  draft: "Draft",
  active: "In-Progress",
  completed: "Completed",
  cancelled: "Cancelled",
};

export const APPROACHING_COMPLETION_DAYS = 14;

export const REVIEW_STATUSES = [
  { value: "NOT_STARTED", label: "Not Started", color: "#6b7280" },
  { value: "PENDING_ARTIFACTS", label: "Pending Artifacts", color: "#ca8a04" },
  { value: "READY_FOR_REVIEW", label: "Ready for Review", color: "#2563eb" },
  { value: "UNDER_REVIEW", label: "Under Review", color: "#4338ca" },
  { value: "NEEDS_MORE_INFO", label: "Needs More Info", color: "#d97706" },
  { value: "PASSED", label: "Passed", color: "#16a34a" },
  { value: "FAILED", label: "Failed", color: "#dc2626" },
  { value: "NOT_APPLICABLE", label: "Not Applicable", color: "#9ca3af" },
];

export const CREATE_DRAFT_STORAGE_KEY = "cloudcatcher:audit-hub-create-draft";

/** AuditAccountRequest.accountNumber */
export const AWS_ACCOUNT_NUMBER = /^\d{12}$/;

/** CreateAuditRequest.accounts maxItems */
export const MAX_AUDIT_ACCOUNTS = 50;

/** AuditAccountRequest.regions maxItems */
export const MAX_ACCOUNT_REGIONS = 32;

/** AuditAccountRequest.complianceAddonIds maxItems */
export const MAX_ACCOUNT_FRAMEWORKS = 32;

/** Default true until the Audit Hub API is deployed. Set REACT_APP_AUDIT_HUB_MOCK=false to use live HTTP. */
export const AUDIT_HUB_USE_MOCK =
  String(process.env.REACT_APP_AUDIT_HUB_MOCK ?? "true").toLowerCase() !== "false";
